import { axios } from './axios';

/**
 * Does some very basic duck-typing to determine if the provided param is axios or not.
 *
 * Returns true if it thinks it is, otherwise false.
 *
 * @param {any} obj
 */
var isAxios = function isAxios(obj) {
  return typeof obj !== 'undefined' && typeof obj.get === 'function' && typeof obj.post === 'function';
};

/**
 * Defers calling of the provided function until params are known.
 *
 * Once params are passed in, it runs some inference to determine if the axios api has been provided.
 *
 * If so, that will be passed through, if not the default library implementation will be injected.
 *
 * @param {Function} fn The function to call
 */
var injectAxios = function injectAxios(fn) {
  var axiosOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    autoAuth: true,
    useBackoff: true
  };
  return function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }
    if (params && params.length && isAxios(params[0])) {
      return Promise.resolve(fn.apply(void 0, params));
    }
    return axios(axiosOptions).then(function (api) {
      return fn.apply(void 0, [api].concat(params));
    });
  };
};
export default injectAxios;